define('common/js/lib/util/nrkno-snowplow',['common/js/lib/util/loader'], function (Loader) {
  var nrknoSnowplowVersion = 'major/1'
  /**
   * Get nrkno-snowplow bundle
   * @note Callback will never fire on network error.
   * @param {(bundle: {}) => void} [callback] on bundle load.
   */
  function getBundle(callback) {
    // Add callback queue placeholder if needed
    var key = 'nrknoOnTrackerReady-1';

    if (window[key] === undefined) {
      window[key] = function (cb) {
        (window[key].q = window[key].q || []).push(cb);
      };
    }
  
    // load script if needed
    Loader.loadJS('https://static.nrk.no/nrkno-snowplow/'+ nrknoSnowplowVersion +'/nrkno-snowplow-entry.js', {});
  
    // Callback will be run if/when entry file is loaded.
    window[key](callback);
  }

  return {
    getBundle: getBundle,
  };
});
